import React, { useState } from "react";
import { Link } from "react-router-dom";
import { apiRoot, getHeaders, propositionUrl } from "../apihelpers";
import { Proposition } from "../shared/interfaces";

const AdminTools = ({
  proposition,
  getProposition,
}: {
  proposition: Proposition;
  getProposition: Function;
}) => {
  const [recalcCount, setRecalcCount] = useState(null);

  const copyProp = () => {
    let headers = getHeaders();
    fetch(propositionUrl + "/copy", {
      method: "POST",
      headers,
      body: JSON.stringify({ id: proposition.id }),
    })
      .then((res) => res.json())
      .then(
        (data) =>
          (window.location.href = `${apiRoot}admin/rouleurderby/proposition/${data.newID}/change/`)
      );
  };

  const recalcProp = () => {
    let headers = getHeaders();
    fetch(propositionUrl + "/recalculate", {
      method: "POST",
      headers,
      body: JSON.stringify({ id: proposition.id }),
    })
      .then((res) => res.json())
      .then((data) => {
        setRecalcCount(data.count);
        getProposition();
      })
      // eslint-disable-next-line no-console
      .catch((error) => console.log(error));
  };

  return (
    <>
      <div className="button-group">
        <a
          className="button"
          href={`${apiRoot}admin/rouleurderby/proposition/${proposition.id}/change/`}
        >
          Edit
        </a>
        {proposition.status !== 4 && (
          <Link to={`/scratch/${proposition.slug}`} className="button">
            scratch
          </Link>
        )}
        {!proposition.coming && proposition.status !== 4 && (
          <Link to={`/score/${proposition.slug}`} className="button">
            score
          </Link>
        )}
        <button className="button" onClick={() => copyProp()}>
          Copy
        </button>
        <button className="button" onClick={() => recalcProp()}>
          Recalculate
        </button>
      </div>
      {recalcCount !== null && <p>Options updated: {recalcCount}</p>}
    </>
  );
};

export default AdminTools;
